import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import { CiBookmark } from "react-icons/ci";
import Button from "../../components/button/button.component";
import ColorField from "../../components/color-filed/color-filed.component";
import NumberFiled from "../../components/number-fileld/number-field.component";
import ProductSlider from "../../components/product-slider/product-slider.component";
import ProductSmallImageSlider from "../../components/product-small-image-slider/product-small-image-slider.component";
import "./product-page.styles.css";

const ProductPage = () => {
  const { id } = useParams();
  const [productData, setProductData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0); // ایندکس تصویر انتخاب‌شده

  // دریافت اطلاعات محصول
  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(
          `https://mediumaquamarine-rat-574365.hostingersite.com/api/details-product/${id}`
        );
        if (response.data.is_status) {
          setProductData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductDetails();
  }, [id]);

  // پیش‌لود تصاویر پس از دریافت اطلاعات محصول
  useEffect(() => {
    if (productData) {
      const images = Object.keys(productData)
        .filter((key) => key.startsWith("image"))
        .map((key) => productData[key])
        .filter(Boolean);

      images.forEach((imgUrl) => {
        const img = new Image();
        img.src = imgUrl;
      });
    }
  }, [productData]);

  const handleAddToCart = () => {
    if (!selectedColor) {
      alert("لطفاً یک رنگ را انتخاب کنید.");
      return;
    }

    const newProduct = {
      id: productData.id,
      title: productData.title,
      price: productData.discount_price
        ? productData.discount_price
        : productData.price,
      quantity,
      colorId: selectedColor.id,
      colorName: selectedColor.color,
      image: productData.image,
    };

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingProductIndex = existingCart.findIndex(
      (item) => item.id === newProduct.id && item.colorId === newProduct.colorId
    );

    if (existingProductIndex >= 0) {
      existingCart[existingProductIndex].quantity += quantity;
    } else {
      existingCart.push(newProduct);
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));

    const cartUpdateEvent = new CustomEvent("cartUpdated", {
      detail: existingCart,
    });
    window.dispatchEvent(cartUpdateEvent);

    console.log("سبد خرید شما:", existingCart);
    alert(`محصول به سبد خرید اضافه شد!\n`);
  };

  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!productData) {
    return <p>Product not found.</p>;
  }

  // استخراج تصاویر به صورت داینامیک
  const images = Object.keys(productData)
    .filter((key) => key.startsWith("image"))
    .map((key) => productData[key])
    .filter(Boolean);

  const { title, price, description } = productData;
  const formatPrice = (price) => {
    return Number(price).toLocaleString("fa-IR");
  };

  return (
    <div className="product-page">
      <div className="product-page-main-wrapper">
        <div className="container">
          <div className="path-text-wrapper">
            <Link to="/">
              <p className="path-text">خانه</p>
            </Link>
            <span className="path-line"></span>
            <Link to="/shop-page">
              <p className="path-text">فروشگاه</p>
            </Link>
            <span className="path-line"></span>
            <p className="path-text">اطلاعات محصول</p>
          </div>
          <div className="produt-page-content-wrapper">
            <div className="product-page-img-wrapper">
              <ProductSlider
                images={images}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
              <ProductSmallImageSlider
                images={images}
                onThumbnailClick={(index) => setCurrentIndex(index)}
              />
            </div>
            <div className="product-page-description-wrapper">
              <div className="product-page-info-wrapper">
                <h1 className="product-page-title">{title}</h1>
                <p className="product-page-price">
                  {productData.discount_price ? (
                    <>
                      <span className="original-price invalid-price">
                        {formatPrice(price)}
                      </span>
                      <span className="discounted-price">
                        {formatPrice(productData.discount_price)} ریال
                      </span>
                    </>
                  ) : (
                    <span className="original-price">
                      {formatPrice(price)} ریال
                    </span>
                  )}
                </p>
                <p className="product-page-description">
                  {description.split("\r\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <div className="product-add-to-cart-and-color-wrapper">
                <div className="color-selection">
                  {productData.colors.some(
                    (color) =>
                      parseInt(color.count, 10) > parseInt(color.sold_count, 10)
                  ) ? (
                    <ColorField
                      colors={productData.colors.filter(
                        (color) =>
                          parseInt(color.count, 10) >
                          parseInt(color.sold_count, 10)
                      )}
                      onColorSelect={(colorId) => {
                        const selected = productData.colors.find(
                          (c) => c.id === colorId
                        );
                        setSelectedColor(selected);
                      }}
                    />
                  ) : (
                    <p className="out-of-stock-message">!تموم شد</p>
                  )}
                </div>
                <NumberFiled
                  value={quantity}
                  onChange={(val) => setQuantity(val)}
                />
                <Button onClick={handleAddToCart}>اضافه به سبد خرید</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
